const fieldNewsTypes = [
  { label: 'Wiadomość tekstowa', value: 1 },
  { label: 'Galeria zdjęć', value: 2 },
  { label: 'Video', value: 3 },
];

export default fieldNewsTypes;
